import React from 'react';
import { Link } from 'react-router-dom';
import { useCan } from '../store';
import { Resource, Verb } from '../api/authz';

interface Props {
    /** 无权限时整个不渲染 (默认降级为不可点的灰标签). 管理入口类链接用它: 普通用户不该看到"去管理"的提示 */
    hide?: boolean;
    to: string;
    resource: Resource;
    verb?: Verb;
    className?: string;
    title?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    children: React.ReactNode;
}

/**
 * 按资源权限决定是否可点的链接 (2026-09-01, 取代按 isAdmin 判定的 AdminLink).
 *
 * 无权限的人点进去只会撞 PermissionRoute 的"无权访问", 所以这里直接降级成不可点的
 * 同款标签 —— 视觉不跳变, 但不给出会失败的入口.
 */
const PermissionLink = ({
    to,
    resource,
    verb = 'get',
    className = '',
    title,
    hide,
    onClick,
    children,
}: Props) => {
    const allowed = useCan(resource, verb);
    if (!allowed && hide) return null;
    if (!allowed) {
        return (
            <span
                className={`${className} cursor-not-allowed opacity-60`}
                title="无权访问该页面"
            >
                {children}
            </span>
        );
    }
    return (
        <Link to={to} className={className} title={title} onClick={onClick}>
            {children}
        </Link>
    );
};

export default PermissionLink;
